import Swiper from 'swiper';
if (!customElements.get('comparison-slider')) {
  customElements.define(
    'comparison-slider',
    class ComparisonSlider extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('swiper-container');

        this.options = {
          slidesPerView: 'auto',
          on: {
            slideChange: () => {
              if (this.slider.swiper.isEnd) {
                this.classList.add('last-slide');
              } else {
                this.classList.remove('last-slide');
              }
            },
          },
        };

        Object.assign(this.slider, this.options);
        this.slider.initialize();
      }
    }
  );
}
